import styled from "styled-components";
import colors from "styles/colors";

export const HeaderCompany = styled.header`
  display: flex;
  height: 80px;
  padding: 0px 24px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
  background: ${colors.punch[600]};
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1 0 0;
`;

export const DivLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;

  .walljobs-logo {
    width: 52.676px;
    height: 47.644px;
  }
`;

export const DivRight = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;
  flex: 1 0 0;

  .avatar_container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
  }

  .company_name {
    color: ${colors.brightGray[50]};
    text-align: center;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 160%;
    letter-spacing: 0.15px;
    margin-top: 8px;

    @media (max-width: 768px) {
      display: none;
    }
  }
`;

export const AvatarBox = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 32px;
`;

export const Apps = styled.svg`
  cursor: pointer;
`;